import Auth from './Auth'
import {
    FORGET_PASSWORD,
    loadProfile,
    LOGIN_CHECK_CALLBACK,
    LOGIN_ERROR,
    LOGIN_INITIAL_CHECK,
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    loginError,
    loginSuccess,
    LOGOUT,
    REGISTER_REQUEST,
    RENEW_TOKEN_CHECK
} from '../actions'
import {push} from 'react-router-redux'
import {getStore} from '../store'

export const auth = new Auth();
const homeUrl = './return';

const authMiddleware = store => next => action => {
    next(action);

    switch(action.type) {
        case REGISTER_REQUEST:
            if(action.payload.type === "employee") {
                auth.registerEmployee();
            } else {
                auth.register(action.payload.type);
            }
            break;
        case FORGET_PASSWORD:
            auth.forgetPassword();
            break;
        case LOGIN_SUCCESS:
            store.dispatch(loadProfile());
            break;
        case LOGIN_REQUEST:
            auth.authorise();
            break;
        case LOGIN_ERROR:
            store.dispatch(push(`./login?message=${action.message}`));
            break;
        case LOGOUT:
            auth.logout();
            getStore().dispatch(push('./login'));
            break;
        case LOGIN_INITIAL_CHECK:
            if(auth.isAuthenticated()) {
                store.dispatch(loginSuccess(convertAccount(auth.getAuthResult())));
            }
            break;
        case LOGIN_CHECK_CALLBACK:

            if (/access_token|id_token|error/.test(store.getState().router.location.hash)) {
                auth.handleAuthentication((err, authResult) => {
                    if(err) {
                        store.dispatch(loginError(err.message));
                    } else {
                        store.dispatch(loginSuccess(convertAccount(authResult)));
                        //TODO route them into the page they are trying to get to
                        store.dispatch(push(homeUrl));
                    }
                });
            }
            else {
                store.dispatch(loginError('Invalid callback hash'));
            }
            break;
        case RENEW_TOKEN_CHECK:
            auth.checkRenewedToken();
            break;
        default: 
            break;
    }
};

const convertAccount = (authResult) => ({
    ...authResult,
    permissions: authResult.idTokenPayload['http://portal.evoenergy/claims/permissions'],
    roles: authResult.idTokenPayload['http://portal.evoenergy/claims/roles'],
    groups: authResult.idTokenPayload['http://portal.evoenergy/claims/groups']
});

export default authMiddleware;



// WEBPACK FOOTER //
// ./src/auth/authMiddleware.js